var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitechartImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0.799927H0.5V18.7999H18.5V0.799927Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15625 18.2379H3.03125C2.80747 18.2379 2.59286 18.149 2.43462 17.9907C2.27639 17.8325 2.1875 17.6179 2.1875 17.3941V12.3316C2.1875 12.1078 2.27639 11.8932 2.43462 11.735C2.59286 11.5767 2.80747 11.4879 3.03125 11.4879H4.15625C4.38002 11.4879 4.59463 11.5767 4.75287 11.735C4.9111 11.8932 5 12.1078 5 12.3316V17.3941C5 17.6179 4.9111 17.8325 4.75287 17.9907C4.59463 18.149 4.38002 18.2379 4.15625 18.2379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0313 18.2369H10.9063C10.6825 18.2369 10.4679 18.148 10.3097 17.9898C10.1514 17.8316 10.0625 17.617 10.0625 17.3932V8.95569C10.0625 8.73191 10.1514 8.5173 10.3097 8.35907C10.4679 8.20083 10.6825 8.11194 10.9063 8.11194H12.0313C12.2551 8.11194 12.4697 8.20083 12.6279 8.35907C12.7861 8.5173 12.875 8.73191 12.875 8.95569V17.3932C12.875 17.617 12.7861 17.8316 12.6279 17.9898C12.4697 18.148 12.2551 18.2369 12.0313 18.2369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 18.2373H14.8438C14.62 18.2373 14.4054 18.1484 14.2471 17.9902C14.0889 17.8319 14 17.6173 14 17.3936V5.01855C14 4.79478 14.0889 4.58017 14.2471 4.42193C14.4054 4.2637 14.62 4.1748 14.8438 4.1748H15.9688C16.1925 4.1748 16.4072 4.2637 16.5654 4.42193C16.7236 4.58017 16.8125 4.79478 16.8125 5.01855V17.3936C16.8125 17.6173 16.7236 17.8319 16.5654 17.9902C16.4072 18.1484 16.1925 18.2373 15.9688 18.2373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 18.2371H6.96875C6.74497 18.2371 6.53036 18.1482 6.37213 17.99C6.2139 17.8318 6.125 17.6171 6.125 17.3934V2.20587C6.125 1.9821 6.2139 1.76748 6.37213 1.60925C6.53036 1.45102 6.74497 1.36212 6.96875 1.36212H8.09375C8.31753 1.36212 8.53214 1.45102 8.69037 1.60925C8.84861 1.76748 8.9375 1.9821 8.9375 2.20587V17.3934C8.9375 17.6171 8.84861 17.8318 8.69037 17.99C8.53214 18.1482 8.31753 18.2371 8.09375 18.2371Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitechartImg);
export default __webpack_public_path__ + "static/media/whitechart-img.ed4a710e66ece7fcc2e93cead0e48aa9.svg";
export { ForwardRef as ReactComponent };